import type { SVGProps } from "react";
import React from "react";

export function CancelIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="2" />
      <line x1="13.7071" y1="2.70711" x2="3.70711" y2="12.7071" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}
